/** @jsxImportSource @emotion/react */
import { Tooltip as MUITooltip } from '@mui/material';
import { createStyles, Typography } from '../../..';
import { type Props } from '../Tooltip';

export const DefaultTooltip = ({
  title,
  placement,
  children,
  open,
  onClose,
}: Props) => {
  const styles = useStyles();

  return (
    <div css={styles.default}>
      <MUITooltip
        PopperProps={{
          disablePortal: true,
        }}
        title={<Typography variant="bodySmall">{title}</Typography>}
        placement={placement}
        arrow
        {...(typeof open === 'boolean' && onClose
          ? {
              open,
              onClose,
              disableHoverListener: true,
              disableFocusListener: true,
              disableTouchListener: true,
            }
          : {})}
      >
        <div>{children}</div>
      </MUITooltip>
    </div>
  );
};

const useStyles = createStyles(({ palette, spacing, shape }) => ({
  default: {
    '.MuiTooltip-tooltip': {
      borderRadius: `calc(${shape.borderRadius}/2)`,
      background: palette.grey.x900,
      padding: spacing.xxxs,
    },
    '.MuiTooltip-arrow': {
      color: palette.grey.x900,
    },
  },
}));
